import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SweetAlert from 'react-bootstrap-sweetalert';

function AdminHeader() {
    const Navigate = useNavigate()
    const didMountRef = useRef(true)
    const [show, setShow] = useState(false)
    useEffect(() => {
        if (didMountRef.current) {

        }
        didMountRef.current = false;
    })


    const Confirm = () => {
        localStorage.removeItem('USER_DATA');
        Navigate("/")

    }
    const logOut = () => {
        setShow(true)
    }
    const Cancelalert = () => {
        setShow(false)
    }
    return (
        <>
            <header id="page-topbar">
                <div class="layout-width">
                    <div class="navbar-header d-flex justify-content-end">
                        <div class="d-flex justify-content-end">
                            <div class="dropdown ms-sm-3 header-item topbar-user ">
                                <button type="button" class="btn" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span class="d-flex align-items-center">
                                        <img class="rounded-circle header-profile-user" src="/assets/images/users/avatar-1.jpg" alt="Header Avatar" />
                                        <span class="text-start ms-xl-2">
                                            <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">Proptrail</span>
                                        </span>
                                    </span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-end">
                                    <h6 class="dropdown-header">Welcome Proptrail!</h6>
                                    <a class="dropdown-item" onClick={logOut}><i class="mdi mdi-logout text-muted fs-16 align-middle me-1" ></i> <span class="align-middle" data-key="t-logout">Logout</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <SweetAlert warning confirmBtnCssClass='alertpop' title={` Are you sure ? you want to logout `} confirmBtnText='Confirm'
                cancelBtnText="Cancel"
                show={show} onConfirm={Confirm} onCancel={Cancelalert} btnSize="md" showCancel
                cancelBtnBsStyle="danger"
            >
            </SweetAlert>
        </>
    )
}
export default AdminHeader